import React from "react";

import { IconMainMenuMetrics } from "~/components/icon";

import { BREADCRUMB_ICON_CLASS } from "../../../components/react/icon/Icon";
import { useNavigateToLink } from "../../../components/react/link";
import { METRICS_PATH } from "../../Routes";
import { BreadcrumbLayout } from "../BreadcrumbLayout";

export const MetricsBreadcrumb = () => {
	const link = useNavigateToLink(METRICS_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<BreadcrumbLayout icon={<IconMainMenuMetrics className={BREADCRUMB_ICON_CLASS} />} label="Metrics" to={link} />
	);
};

MetricsBreadcrumb.PATH = METRICS_PATH;
